import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { ROOT_URL } from '../../../../redux/constants';
import { FormattedMessage } from 'react-intl';
import {
    Button,
    Typography,
    IconButton,
    FormGroup,
    TextField,
    MenuItem,
    Divider
} from '@material-ui/core';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import Slider from '@material-ui/core/Slider';
import { Close } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import { fetchLevels } from '../../../../redux/actions';
import baseStyle from '../../../../styles/wizardBase';

class MonsterCafeSkillDatabank extends Component {

    state = {
        tested: false,
        error: {},
        difficulty: 'Easy',
        speed: 1.0,
        background_noise: 50,
        max_ingredient: 3,
        max_patience: 10,
        min_patience: 5,
        visibleOrder: true
    };

    componentDidMount() {
        if (this.props.level.id) {
            const variables = JSON.parse(this.props.level.levelJson);
            const {
                speed,
                max_patience,
                max_ingredient,
                min_patience,
                visibleOrder
            } = variables;
            const background_noise = variables.background_noise * 100;
            this.setState({
                difficulty: this.props.level.difficulty,
                speed,
                background_noise,
                max_patience,
                max_ingredient,
                min_patience,
                visibleOrder
            })
        }
    }

    close = () => {
        this.props.close();
        this.setState({
            tested: false,
            error: {},
            difficulty: 'Easy',
            directionType: '',
            step_count: '1',
            type:''
        })
    };

    runTest = () => {
        const {
            tested,
            speed,
            max_patience,
            max_ingredient,
            min_patience,
            visibleOrder,
            difficulty
        } = this.state;
        const background_noise = this.state.background_noise / 100.0;
        const url = this.props.type === 'staff' ? `${ROOT_URL}/staff/${this.props.id}/objective-databank/test`: `${ROOT_URL}/admin/objective-databank/test`;
        if (tested) this.clearTest();
        axios.post(url, { levelVariables: JSON.stringify({
                speed,
                background_noise,
                max_patience,
                max_ingredient,
                min_patience,
                visibleOrder
            }), templateId: "-2521545290932261544" })
            .catch(err => console.log(err));
        this.setState({ tested: true });
    };

    clearTest = () => {
        const url = this.props.type === 'staff' ? `${ROOT_URL}/staff/${this.props.id}/objective-databank/test`: `${ROOT_URL}/admin/objective-databank/test`;
        axios.delete(url)
            .catch(err => console.log(err));
        this.setState({ tested: false })
    };

    handleSliderChange = (ev, newVal, name) => {
        this.setState({ [name]: newVal })
    };

    handleChange = (ev) => {
        const value = ev.target.type === 'number' ? ev.target.value > 0 ? ev.target.value * 1 : '' : ev.target.value;
        this.setState({ [ev.target.name]: value })
    };

    checkForErrors = (ev) => {
        if (!ev.target.value){
            this.setState({ error: {...this.state.error, [ev.target.name]: true }})
        }
        else {
            let error = this.state.error;
            delete error[ev.target.name];
            this.setState({ error })
        }
    };

    handleSubmit = (ev) => {
        ev.preventDefault();
        const {
            speed,
            max_patience,
            max_ingredient,
            min_patience,
            visibleOrder,
            difficulty
        } = this.state;
        const background_noise = this.state.background_noise / 100.0;
        const levelJson = JSON.stringify({
            speed,
            background_noise,
            max_patience,
            max_ingredient,
            min_patience,
            visibleOrder
        });
        this.props.onSubmit({ levelTemplateId: "-2521545290932261544", levelJson, difficulty });
    };

    render()  {
        const { classes, open, close, back, levels, game } = this.props;
        const { tested, error } = this.state;
        const disabled = Object.keys(error).length > 0 || !this.state.max_ingredient || !this.state.min_patience
            || !this.state.max_patience || !this.state.speed;
        return (
            <Dialog
                disableEscapeKeyDown
                fullWidth={true}
                open={open}
                onClose={close}
                aria-labelledby='skill-dialog-title'
                scroll='paper'
                PaperProps={{ classes:{ root: classes.container }}}
            >
                <DialogTitle disableTypography={true} className={ classes.title }>
                    <Typography className={ classes.titleText } variant='h4' id='skill-dialog-title'><FormattedMessage id='Wizard.skillDB.title'/></Typography>
                    <IconButton
                        onClick={this.close}
                        className={ classes.exitIcon }
                        aria-label="close dialog button"
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Typography gutterBottom variant='h3'>
                        <FormattedMessage id='Wizard.Monster.title'/>
                    </Typography>
                    <Typography className={classes.description} variant='subtitle1'>
                        <FormattedMessage id='Wizard.Monster.subtitle'/>
                    </Typography>
                    <Divider />
                    <div className={classes.level}>
                        <FormGroup className={classes.configureLine}>
                            <Typography className={classes.configTitle} variant='h6'><FormattedMessage id='Wizard.Monster.speed' />: </Typography>
                            <Slider
                                className={classes.arcSlider}
                                value={this.state.speed}
                                onChange={(ev, newVal) => this.handleSliderChange(ev, newVal, 'speed')}
                                aria-labelledby="discrete-slider"
                                valueLabelDisplay="auto"
                                defaultValue={1.0}
                                step={.25}
                                marks
                                min={.5}
                                max={1.5}
                            />
                        </FormGroup>
                        <FormGroup className={classes.configureLine}>
                            <Typography className={classes.configTitle} variant='h6'><FormattedMessage id='Wizard.Monster.backgroundVolume' />: </Typography>
                            <Slider
                                className={classes.arcSlider}
                                value={this.state.background_noise}
                                onChange={(ev, newVal) => this.handleSliderChange(ev, newVal, 'background_noise')}
                                aria-labelledby="discrete-slider"
                                valueLabelDisplay="auto"
                                defaultValue={50}
                                step={10}
                                marks
                                min={0}
                                max={100}
                            />
                        </FormGroup>
                        <FormGroup className={classes.configureLine}>
                        <Typography
                                                                className={classes.configTitle} variant='h6'><FormattedMessage id='Wizard.Monster.MaxIngrediants'/>: </Typography>
                        <TextField
                            variant='outlined'
                            className={classes.configComponent}
                            type='number'
                            name='max_ingredient'
                            onBlur={this.checkForErrors}
                            error={error.max_ingredient}
                            helperText={error.max_ingredient ? '* required' : ''}
                            onChange={this.handleChange}
                            value={this.state.max_ingredient}
                        />
                    </FormGroup>
                        <FormGroup className={classes.configureLine}>
                            <Typography
                                                                    className={classes.configTitle} variant='h6'><FormattedMessage id='Wizard.Monster.MinPatience'/>: </Typography>
                            <TextField
                                variant='outlined'
                                className={classes.configComponent}
                                type='number'
                                name='min_patience'
                                onBlur={this.checkForErrors}
                                error={error.min_patience}
                                helperText={error.min_patience ? '* required' : ''}
                                onChange={this.handleChange}
                                value={this.state.min_patience}
                            />
                        </FormGroup>
                        <FormGroup className={classes.configureLine}>
                            <Typography
                                                                    className={classes.configTitle} variant='h6'><FormattedMessage id='Wizard.Monster.MaxPatience'/>: </Typography>
                            <TextField
                                variant='outlined'
                                className={classes.configComponent}
                                type='number'
                                name='max_patience'
                                onBlur={this.checkForErrors}
                                error={error.max_patience}
                                helperText={error.max_patience ? '* required' : ''}
                                onChange={this.handleChange}
                                value={this.state.max_patience}
                            />
                        </FormGroup>
                        <FormGroup className={classes.configureLine}>
                            <Typography className={classes.configTitle} variant='h6'><FormattedMessage id='Wizard.Monster.visible' />: </Typography>
                            <TextField
                                select
                                variant='outlined'
                                className={classes.configComponent}
                                name='visibleOrder'
                                value={this.state.visibleOrder}
                                onChange={this.handleChange}
                            >
                                {
                                    [
                                        { value: true, text: <FormattedMessage id='General.yes' /> },
                                        { value: false, text: <FormattedMessage id='General.no' /> },
                                    ].map(difficulty => (<MenuItem key={difficulty.value} value={difficulty.value}> {difficulty.text} </MenuItem>))
                                }
                            </TextField>
                        </FormGroup>
                        <FormGroup className={classes.configureLine}>
                            <Typography className={classes.configTitle} variant='h6'><FormattedMessage id='General.difficulty' />: </Typography>
                            <TextField
                                select
                                variant='outlined'
                                className={classes.configComponent}
                                name='difficulty'
                                value={this.state.difficulty}
                                onChange={this.handleChange}
                            >
                                {
                                    [
                                        { value: 'Easy', text: <FormattedMessage id='General.easy' /> },
                                        { value: 'Medium', text: <FormattedMessage id='General.medium' /> },
                                        { value: 'Hard', text: <FormattedMessage id='General.hard' /> }
                                    ].map(difficulty => (<MenuItem key={difficulty.value} value={difficulty.value}> {difficulty.text} </MenuItem>))
                                }
                            </TextField>
                        </FormGroup>
                    </div>

                </DialogContent>
                <DialogActions className={classes.buttons}>
                    <Button onClick={back} color='secondary'>
                        <FormattedMessage id='General.back' />
                    </Button>
                    <Button
                        onClick={ this.runTest }
                        variant={ tested ? 'outlined' : 'text' }
                        color={ tested ? 'secondary' : 'primary' }
                    >
                        { tested ? <FormattedMessage id='General.retest' /> : <FormattedMessage id='General.test' /> }
                    </Button>
                    <Button disabled={disabled} onClick={this.handleSubmit} color='primary'>
                        <FormattedMessage id='General.next' />
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const  mapState = ({ platform: { levels }}) => {
    return {
        levels
    }
};

const mapDispatch = (dispatch) => {
    return {
        fetchLevels: () => dispatch(fetchLevels())
    }
};

export default connect(mapState, mapDispatch)(withStyles(baseStyle)(MonsterCafeSkillDatabank));